import { render, staticRenderFns } from "./HtmlForm.vue?vue&type=template&id=08e9638e&"
import script from "./HtmlForm.vue?vue&type=script&lang=ts&"
export * from "./HtmlForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports